{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Ați depășit limita de conversații. Planul Hacker permite doar 500 de conversații.",
      "INBOXES": "Ați depășit limita de inbox-uri. Planul Hacker acceptă doar chat live pe site. Inbox-urile suplimentare precum email, WhatsApp etc. necesită un plan plătit.",
      "AGENTS": "Ați depășit limita de agenți. Planul Hacker permite doar 2 agenți.",
      "NON_ADMIN": "Vă rugăm să contactați administratorul pentru a actualiza planul și a continua să utilizați toate funcțiile."
    },
    "TITLE": "Setări cont",
    "SUBMIT": "Actualizați setările",
    "BACK": "Înapoi",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Nu s-au putut actualiza setările, încercați din nou!",
      "SUCCESS": "Setările contului actualizate cu succes"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Ștergeți contul dumneavoastră",
      "NOTE": "Odată ce vă ștergeți contul, toate datele dumneavoastră vor fi șterse.",
      "BUTTON_TEXT": "Ștergeți contul",
      "CONFIRM": {
        "TITLE": "Ștergere cont",
        "MESSAGE": "Ștergerea contului este ireversibilă. Introduceți numele contului mai jos pentru a confirma că doriți să îl ștergeți definitiv.",
        "BUTTON_TEXT": "Șterge",
        "DISMISS": "Anulează",
        "PLACE_HOLDER": "Vă rugăm să tastați {accountName} pentru a confirma"
      },
      "SUCCESS": "Cont marcat pentru ștergere",
      "FAILURE": "Contul nu a putut fi șters, încercați din nou!",
      "SCHEDULED_DELETION": {
        "TITLE": "Cont programat pentru ștergere",
        "MESSAGE_MANUAL": "Acest cont este programat pentru ștergere la {deletionDate}. Acest lucru a fost solicitat de un administrator. Puteți anula ștergerea înainte de această dată.",
        "MESSAGE_INACTIVITY": "Acest cont este programat pentru ștergere la {deletionDate} din cauza inactivității contului. Puteți anula ștergerea înainte de această dată.",
        "CLEAR_BUTTON": "Anulează ștergerea programată"
      }
    },
    "FORM": {
      "ERROR": "Vă rugăm să remediați erorile din formular",
      "GENERAL_SECTION": {
        "TITLE": "Setări generale",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID cont",
        "NOTE": "Acest ID este necesar dacă construiți o integrare bazată pe API"
      },
      "NAME": {
        "LABEL": "Nume cont",
        "PLACEHOLDER": "Numele contului tău",
        "ERROR": "Te rugăm să introduci un nume de cont valid"
      },
      "LANGUAGE": {
        "LABEL": "Limba site-ului",
        "PLACEHOLDER": "Numele contului tău",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domeniu e-mail de intrare",
        "PLACEHOLDER": "Domeniul în care veți primi e-mailurile",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mail de suport",
        "PLACEHOLDER": "E-mailul de asistență al companiei dumneavoastră",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Numărul de zile de pe bilet ar trebui să se rezolve automat dacă nu există activitate",
        "NOTE": "Numărul de ore de inactivitate după care orice conversație deschisă va fi rezolvată automat.",
        "PLACEHOLDER": "30",
        "ERROR": "Vă rugăm să introduceți o durată validă de rezolvare automată (minim 1 zi și maximum 999 de zile)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Numărul de zile după care o conversație goală va fi rezolvată automat dacă nu există activitate",
        "PLACEHOLDER": "niciodată",
        "ERROR": "Vă rugăm să introduceți o durată validă pentru rezolvarea automată a conversațiilor goale (minim 1 zi și maxim 999 zile)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Continuitatea conversației cu e-mailurile este activată pentru contul dvs.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Puteți primi e-mailuri în domeniul dvs. personalizat acum."
      },
      "PHONE": {
        "TITLE": "Setări PBX",
        "NOTE": "Configurați conexiunea la PBX-ul dumneavoastră pentru apeluri telefonice",
        "SIP_HOST": {
          "LABEL": "Domeniu SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Mod de apelare",
          "MODES": {
            "direct": "Direct - apelul este inițiat imediat la clic pe linkul telefonului",
            "indirect": "Indirect - numărul de telefon este pregătit în câmpul widget-ului telefonului"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Acces la înregistrările apelurilor",
          "MODES": {
            "admin_only": "Doar administratori",
            "admin_and_assigned_agent": "Administratori și agentul atribuit",
            "inbox_members": "Toți agenții cu acces la inbox"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Setări email",
        "NOTE": "Modifică comportamentul inbox-urilor de email"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Mod de afișare a marcajului temporal al conversației",
        "MODES": {
          "both": "Creat și ultima activitate",
          "last_activity_only": "Doar ultima activitate",
          "last_customer_message": "Ultimul mesaj al clientului"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blochează domeniile cu reputație scăzută"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Include mesajul original în răspunsul la email"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Rezolvă automat o conversație nouă"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Mută automat o conversație nouă prin e-mail în inboxul robotului care a procesat comenzile contactului"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Etichete extinse - Permite nume de etichete mai lungi cu o interfață popup mai mare"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Atribuie automat conversația agentului care a creat ultimul răspuns"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Mod notificări push",
        "MODES": {
          "all_inboxes": "Toate inbox-urile - Trimite notificări pentru toate tipurile de canale",
          "chat_only": "Doar chat - Trimite notificări doar pentru canalele non-email"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Permite comutarea semnăturii pe mesajele trimise"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Afișează starea de chat a agentului pe wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Afișează numele complete ale atașamentelor fără trunchiere"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Autentificare cu parolă",
        "MODES": {
          "allowed_for_all": "Permisă pentru toți utilizatorii",
          "allowed_for_agents_only": "Permisă doar pentru agenți (administratorii trebuie să folosească OAuth)",
          "password_login_disabled": "Dezactivată - Doar OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Este disponibilă o versiune nouă. Reîncărcați pentru a obține cele mai recente actualizări.",
    "RELOAD_NOW": "Actualizează acum",
    "LEARN_MORE": "Află mai mult",
    "PAYMENT_PENDING": "Plata dvs. este în așteptare. Vă rugăm să actualizați informațiile de plată pentru a continua să utilizați acest software",
    "LIMITS_UPGRADE": "Contul dvs. a depășit limitele de utilizare, vă rugăm să vă actualizați planul pentru a continua să utilizați acest software",
    "OPEN_BILLING": "Deschide facturarea"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Apăsați enter pentru a selecta",
      "ENTER_TO_REMOVE": "Introduceți numele complet al persoanei de contact",
      "NO_OPTIONS": "Lista este goală",
      "NO_RESULT": "Nu au fost găsite rezultate",
      "SELECT_ONE": "Alege una",
      "SELECT": "Selectați"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notificări",
    "MARK_ALL_DONE": "Marcați toate gata",
    "DELETE_TITLE": "șterse",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notificări necitite",
      "ALL_NOTIFICATIONS": "Vizualizarea tuturor notificărilor",
      "LOADING_UNREAD_MESSAGE": "Încărcarea notificărilor necitite...",
      "EMPTY_MESSAGE": "Nu aveți notificări necitite"
    },
    "LIST": {
      "404": "Notificări prin e-mail",
      "LOADING_MESSAGE": "Se încarcă contactele...",
      "TABLE_HEADER": [
        "Nume",
        "Număr de telefon",
        "Conversații",
        "Ultimul contactat"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Conversație nouă",
      "conversation_assignment": "Conversație atribuită",
      "assigned_conversation_new_message": "Trimite mesaj nou",
      "participating_conversation_new_message": "Trimite mesaj nou",
      "conversation_mention": "Menţiune",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Deconectat",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Reîmprospătare"
    },
    "CONNECTION_LOST": {
      "TITLE": "Conexiune pierdută",
      "DESCRIPTION": "Nu am putut contacta serverul. Verifică conexiunea și încearcă din nou.",
      "RETRY": "Încearcă din nou"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Căutarea sau saltul la",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Rapoarte",
      "CONVERSATION": "Conversație",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Modificarea cesionarului",
      "CHANGE_PRIORITY": "Modificarea priorității",
      "CHANGE_TEAM": "Schimbarea echipei",
      "SNOOZE_CONVERSATION": "Snooze conversație",
      "EXECUTE_MACRO": "Executarea macrocomenzii",
      "ADD_LABEL": "Adăugarea etichetei la conversație",
      "REMOVE_LABEL": "Eliminarea etichetei din conversație",
      "SETTINGS": "Setări",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Accesați Tabloul de bord conversație",
      "GO_TO_CONTACTS_DASHBOARD": "Accesați Tabloul de bord persoane de contact",
      "GO_TO_REPORTS_OVERVIEW": "Accesați Prezentare generală a rapoartelor",
      "GO_TO_CONVERSATION_REPORTS": "Accesați Rapoartele conversațiilor",
      "GO_TO_AGENT_REPORTS": "Accesați povestea Instagram",
      "GO_TO_LABEL_REPORTS": "Accesați Etichetarea rapoartelor",
      "GO_TO_INBOX_REPORTS": "Accesați Rapoarte Inbox",
      "GO_TO_TEAM_REPORTS": "Accesați Rapoarte de echipă",
      "GO_TO_SETTINGS_AGENTS": "Accesați Setări agent",
      "GO_TO_SETTINGS_TEAMS": "Accesați Setările echipei",
      "GO_TO_SETTINGS_INBOXES": "Accesați Setări Inbox",
      "GO_TO_SETTINGS_LABELS": "Accesați Setări etichetă",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Accesați Setări răspuns conservat",
      "GO_TO_SETTINGS_APPLICATIONS": "Accesați Setări aplicație",
      "GO_TO_SETTINGS_ACCOUNT": "Accesați Setări cont",
      "GO_TO_SETTINGS_PROFILE": "Accesați Setări profil",
      "GO_TO_NOTIFICATIONS": "Accesați Notificări",
      "ADD_LABELS_TO_CONVERSATION": "Adăugarea etichetei la conversație",
      "ASSIGN_AN_AGENT": "Atribuirea unui agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Atribuirea priorității",
      "ASSIGN_A_TEAM": "Atribuirea unei echipe",
      "EXECUTE_A_MACRO": "Executarea unei macrocomenzi",
      "MUTE_CONVERSATION": "Silențios conversația",
      "UNMUTE_CONVERSATION": "Sunet conversația",
      "REMOVE_LABEL_FROM_CONVERSATION": "Eliminarea etichetei din conversație",
      "REOPEN_CONVERSATION": "Redeschiderea conversației",
      "RESOLVE_CONVERSATION": "Rezolvarea conversației",
      "SEND_TRANSCRIPT": "Trimiterea unei transcrieri a e-mailului",
      "SNOOZE_CONVERSATION": "Snooze conversație",
      "UNTIL_NEXT_REPLY": "Până la următorul răspuns",
      "UNTIL_NEXT_WEEK": "Până săptămâna viitoare",
      "UNTIL_TOMORROW": "Până mâine",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "Sistem",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Se încarcă aplicația Dashboard..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click aici"
  }
}
